import { CollapseStatus as collapseStatus } from './collapse-status.enum';
import { MatColor as matColor } from './mat-color.enum';
import { BottomPanelPresetHeight as bottomPanelPresetHeight } from './bottom-panel-preset-height.enum';

export namespace Ui {
  export import CollapseStatus = collapseStatus;
  export import MatColor = matColor;
  export import BottomPanelPresetHeight = bottomPanelPresetHeight;
}
